/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'
import moment from 'moment'

import firebase from '../../../config/firebase'
import ItemActions from '../../../reducers/hasuraItemReducer'

class ReportMerchant extends React.Component {
  fileReader = new FileReader()
  fileInputRef = React.createRef()
  downloadLinkRef = React.createRef()

  state = {
    downloading: false,
    downloadUrl: '',
    branchKey: 'all',
    orderIds: [],
  }

  static getDerivedStateFromProps(props, state) {
    const { orderIds: propOrderIds, fetchItems, branchKey: propBranchKey } = props
    const { orderIds, branchKey: stateBranchKey } = state

    if ((propOrderIds.length > 0 && orderIds !== propOrderIds) || stateBranchKey !== propBranchKey) {
      fetchItems(propOrderIds)
      state.orderIds = propOrderIds
      state.branchKey = propBranchKey
      return state
    }

    return false
  }

  onDownloadClick = async () => {
    const { items } = this.props
    const sortedItems = _.sortBy(items, 'created_at')
    const csvString = await this.generateCSV(sortedItems)

    const snapshot = await this.uploadFile(csvString)
    this.downloadFile(snapshot)
  }

  onClearFile = () => {
    this.fileReader.abort()
    this.fileInputRef.value = ''
  }

  generateCSV = async items => {
    let csvString = ''
    const header = [
      'No.',
      'Restaurant',
      'Status',
      'Subtotal',
      'Items',
      'Rejected Code',
      'Description',
      'Purchased at',
    ].join(', ')
    csvString = csvString.concat(`${header} \n`)
    const groupedItems = _.groupBy(items, item => item.firebase_key)
    const groupedItemKeys = Object.keys(groupedItems)
    const groupedItemKeysLength = groupedItemKeys.length

    for (let i = 0; i < groupedItemKeysLength; i += 1) {
      const groupedItemKey = groupedItemKeys[i]

      const order = groupedItems[groupedItemKey]
      const {
        branch_name: branchName,
        merchant_name: merchName,
        subtotal,
        status,
        created_at: createdAt,
        rejected_description,
        rejected_code,
      } = order[0]
      const allOrders = order.map(o => `${o.name} x ${o.quantity}`).join(' - ')
      const purchasedAt = moment(createdAt).format('DD-MMM-YYYY')
      const rowString = [
        i + 1,
        `"${merchName} ${branchName}"`,
        status,
        subtotal,
        `"${allOrders}"`,
        rejected_code,
        rejected_description,
        purchasedAt,
      ].join(', ')
      csvString = csvString.concat(`${rowString} \n`)
    }

    return csvString
  }

  onReadFile = () => {
    const self = this

    this.fileReader.onload = event => {
      const ordersFromJson = JSON.parse(event.target.result)
      self.props.getOrderByDateSuccess(ordersFromJson)
      self.onClearFile()
    }

    this.fileReader.onloadstart = () => {
      self.setState({ uploading: true })
    }
    this.fileReader.onloadend = () => {
      self.setState({ uploading: false })
    }
  }

  onFileChange = e => {
    const file = e.target.files[0]

    if (file) {
      this.onReadFile()
      this.fileReader.readAsText(file)
    }
  }

  uploadFile = async csvString => {
    const { merchant, startFrom, endAt } = this.props
    const { branchKey } = this.state

    const merchantName = merchant.name

    const branchName = branchKey ? merchant.branches[branchKey].name : 'all'
    const storage = firebase
      .storage()
      .ref()
      .child(
        `report/orders-${merchantName}-${branchName}-${moment(startFrom).format('YYYY-MMM-DD')}-to-${moment(
          endAt
        ).format('YYYY-MMM-DD')}.csv`
      )

    this.setState({ downloading: true })

    return storage.putString(csvString.toString())
  }

  downloadFile = snapshot => {
    const self = this
    snapshot.ref.getDownloadURL().then(downloadUrl => {
      self.setState({ downloading: false, downloadUrl }, () => {
        self.downloadLinkRef.click()
      })
    })
  }

  render() {
    const { downloading, downloadUrl } = this.state
    const { items, loading } = this.props
    return (
      <div style={{ display: 'inline' }}>
        <Button
          disabled={downloading || loading || _.size(items) === 0}
          loading={downloading}
          onClick={this.onDownloadClick}
        >
          Download Report
        </Button>
        <a
          href={downloadUrl}
          ref={ref => {
            this.downloadLinkRef = ref
          }}
          style={{ display: 'none' }}
        />
        <input
          type="file"
          accept=".csv"
          hidden
          ref={ref => {
            this.fileInputRef = ref
          }}
          onChange={this.onFileChange}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ hasuraItems }) => ({
  items: hasuraItems.items,
  loading: hasuraItems.loading,
  loaded: hasuraItems.loaded,
})

const mapDispatchToProps = {
  fetchItems: ItemActions.fetchItems,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportMerchant)



// WEBPACK FOOTER //
// ./src/containers/reports/components/ReportMerchantDownloadButton.js